export default {
  storeSurvey (state, payload) {
    state.survey = payload
  },
  listSurveys (state, payload) {
    state.surveys = payload
  },
  destroySurvey (state, payload) {
    state.surveys = state.surveys.filter(survey => {
      return parseInt(survey.id) !== parseInt(payload.id)
    })
  },
  updateSurvey (state, payload) {
    state.surveys = this.surveys.map(survey => {
      if (parseInt(survey.id) === parseInt(payload.id)) {
        return payload
      } else {
        return survey
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/survey/mutations.js